import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './DiscountSelector.module.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PlusIcon from '../icons/PlusIcon';
import SuccessCard from '../SuccessCard/SuccessCard';

const DiscountSelector = ({ discountOptions, onDiscountChange, discountApplied, disabled }) => {
  const { t } = useTranslation();
  const [showDiscountSelector, setShowDiscountSelector] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState(null);

  const onHandleClick = (discount) => {
    const newSelectedDiscount = discount === selectedDiscount ? null : discount;
    setSelectedDiscount(newSelectedDiscount);
    if (onDiscountChange) onDiscountChange(newSelectedDiscount);
  };

  return (
    <>
      <div
        className='fw-600 font-tiny'
        onClick={() => setShowDiscountSelector(!showDiscountSelector)}
      >
        {t('addDiscount')} <PlusIcon color='var(--color-light-green)' size={16} />
      </div>

      <div className={`${styles.containerWrapper} ${showDiscountSelector && styles.show}`}>
        <div className='font-extra-small text-alternative mt-1'>{t('addDiscountDescription')}</div>
        <div className={`mt-3 ${disabled ? styles.disabled : ''}`}>
          <Swiper spaceBetween={10} slidesPerView={'auto'}>
            {discountOptions.length > 0 &&
              discountOptions.map((discount, index) => (
                <SwiperSlide key={index}>
                  <button
                    className={`${styles.buttonDiscount} ${
                      selectedDiscount === discount ? styles.active : ''
                    } ${disabled ? styles.disabled : ''}`}
                    onClick={() => !disabled && onHandleClick(discount)}
                  >
                    {discount}%
                  </button>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>

        {discountApplied && (
          <div className={`mt-2 ${disabled ? styles.disabled : ''}`}>
            <SuccessCard
              title={t('discountAppliedSuccessfully')}
              description={t('discountAppliedSuccessfullyDescription')}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DiscountSelector;
